import { useParams } from 'react-router-dom';

export const useGetOrderNumber = (): string | undefined => {
  const { id } = useParams<{ id: string }>();
  return id;
};
